import { yupResolver } from '@hookform/resolvers/yup'
import AddTaskIcon from '@mui/icons-material/AddTask'
import ApprovalIcon from '@mui/icons-material/Approval'
import TextSnippetIcon from '@mui/icons-material/TextSnippet'
import { LoadingButton } from '@mui/lab'
import {
  Autocomplete,
  Box,
  Button,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from '@mui/material'
import { useAppDispatch, useAppSelector } from 'app/hooks'
import { UIAction } from 'app/slices/UI'
import FloorMap from 'components/Event/FloorMap'
import OpenStressMap from 'components/Map'
import { useSnackbar } from 'notistack'
import { Fragment, useEffect, useMemo, useRef, useState } from 'react'
import { SubmitHandler, useForm } from 'react-hook-form'
import { useNavigate, useParams } from 'react-router-dom'
import axiosClient from 'utils/axiosClient'
import { loadImageProcessToCanvas } from 'utils/imageConvert'
import DeleteIcon from '@mui/icons-material/Delete'
import * as yup from 'yup'
import { SurveyType } from 'interface'
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle'
import EventIcon from '@mui/icons-material/Event'
import AddCircleIcon from '@mui/icons-material/AddCircle'
// interface FormInput {
//   eventId: number
//   templateId: number
//   name: string
//   lat: number
//   lng: number
//   quizText?: string
//   quizAnswers: string
//   hint?: string
//   answeredImage?: string
//   answeredText?: string
// }
const schema = yup.object({
  // eventId: yup.number().required(),
  // lat: yup.number().required(),
  // lng: yup.number().required(),
  // name: yup.string().required(),
  // quizAnswers: yup.string().required(),
  // templateId: yup.number().required(),
})
let timer: any
const initStepStyle = {
  value: '',
  color: '#000',
  fontSize: 20,
}
interface FormInput {
  text: string
  type: SurveyType
}
export default function AddSurvey() {
  const [deleteConfirm, setDeleteConfirm] = useState(false)
  const navigate = useNavigate()
  const { enqueueSnackbar } = useSnackbar()
  const inputRef = useRef({} as HTMLInputElement)
  const inputPosValueRef = useRef({} as HTMLInputElement)
  const canvasRef = useRef({} as HTMLCanvasElement)
  const [image, setImage] = useState<HTMLCanvasElement>()
  const { id } = useParams<{ id: string }>()
  const event = useAppSelector((s) =>
    s.Event.list.find((f) => f.id === Number(id))
  )
  const templates = useAppSelector((s) => s.UI.templates)
  const {
    register,
    handleSubmit,
    formState: { errors },
    getValues,
    setValue,
  } = useForm<FormInput>({
    resolver: yupResolver(schema),
    defaultValues: {
      // eventId: Number(id),
      // templateId: 0,
      type: 'free',
    },
  })
  const [loading, setLoading] = useState(false)
  const [positionValues, setPositionValues] = useState<
    {
      value: string
      color: string
      fontSize: number
    }[]
  >([])
  const [state, setState] = useState<{
    value: string
    color: string
    fontSize: number
  }>(initStepStyle)
  const [step, setStep] = useState(0)

  // const selectedTemplate = useMemo(() => {
  //   if (getValues('templateId')) {
  //     return templates.find((f) => f.id === getValues('templateId'))
  //   } else return undefined
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [getValues('templateId'), templates])
  const dispatch = useAppDispatch()
  useEffect(() => {
    dispatch(
      UIAction.setBreadcrumbs([
        {
          text: 'ホーム',
          url: '/',
        },
        {
          text: 'イベント一覧',
          url: '/event',
        },
        {
          text: 'イベント詳細',
          url: '/event/' + event?.id,
        },
        {
          text: 'アンケート作成',
          url: '/event/' + event?.id + '/survey',
        },
      ])
    )
  }, [dispatch, event?.id, event?.name])
  const onSubmit: SubmitHandler<FormInput> = async (data) => {
    // console.log(data)
    // if (
    //   positionValues.filter((f) => f.value).length !==
    //   selectedTemplate?.positions.length
    // ) {
    //   const msg = 'チェックポイントは全部入力が必要です'
    //   enqueueSnackbar(msg, {
    //     variant: 'error',
    //   })
    //   const area = document.getElementById('position-input')
    //   if (area) {
    //     area.scrollIntoView({
    //       block: 'center',
    //       behavior: 'smooth',
    //     })
    //     area.classList.add('bg-red-200')
    //   }
    //   return
    // }
    await handleCreateSurvey(data)
  }

  const handleChangeState = async (
    key: keyof typeof state,
    value: string | number
  ) => {
    await new Promise((rs) => {
      if (timer) clearTimeout(timer)
      timer = setTimeout(() => {
        setState({
          ...state,
          [key]: value,
        })
        rs(1)
      }, 200)
    })
  }

  const handleCreateSurvey = async (data: FormInput) => {
    try {
      const selectableSurvey = data.type === 'select' ? selectBoxes : data.type === 'radio' ? radios : ''
      setLoading(true)
      await axiosClient.post('/api/events/' + id + '/surveys', {
        data: JSON.stringify({ text: data.text, type: data.type, selectableSurvey: selectableSurvey }),
      })
      setLoading(false)
      const msg = 'アンケートを作成しました。'
      enqueueSnackbar(msg, {
        variant: 'success',
      })
      navigate('/event/' + id)
      console.log(selectBoxes)
    } catch (_error) {
      const msg = 'エラーが発生しました。'
      enqueueSnackbar(msg, {
        variant: 'error',
      })
    }
  }
  const [selectBoxes, setSelectBoxes] = useState<
    {
      text: string
      value: number
    }[]
  >([])
  const [radios, setRadios] = useState<
    {
      text: string
      value: number
    }[]
  >([])

  if (!event) return null
  return (
    <>
      <Grid item xs={12} mt={3}>
        <Typography
          variant="h5"
          component="h2"
          sx={{ borderBottom: 2 }}
          fontWeight="bold"
        >
          {event.name}
        </Typography>
      </Grid>
      <Box
        component="form"
        noValidate
        autoComplete="off"
        onSubmit={handleSubmit(onSubmit)}
        my={2}
      >
        <TextField
          margin="dense"
          label="質問文"
          fullWidth
          variant="standard"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <TextSnippetIcon color="primary" />
              </InputAdornment>
            ),
          }}
          {...register('text')}
          error={'text' in errors}
        />
        <InputLabel>回答タイプ選択</InputLabel>
        <Select
          value={getValues('type')}
          label="回答タイプ選択"
          onChange={(event) => {
            setValue('type', event.target.value as SurveyType, {
              shouldValidate: true,
            })
          }}
        >
          <MenuItem value={'free'}>文字入力（任意）</MenuItem>
          <MenuItem value={'select'}>セレクトボックス</MenuItem>
          <MenuItem value={'radio'}>ラジオボタン</MenuItem>
          {/* <MenuItem value={'checkbox'}>チェックボックス</MenuItem> */}
        </Select>
        {getValues('type') === 'select' && (
          <>
            <Typography variant="body1" component="p" fontWeight="bold">
              セレクトボックス項目の作成
            </Typography>
            {selectBoxes.map((v, i) => {
              return (
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="baseline"
                  key={i}
                >
                  <Stack flex={1}>
                    <TextField
                      required
                      margin="dense"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <EventIcon color="primary" />
                          </InputAdornment>
                        ),
                      }}
                      label="項目"
                      fullWidth
                      variant="standard"
                      value={v.text}
                      onChange={(e) => {
                        const tmp = [...selectBoxes]
                        tmp.splice(i, 1, {
                          ...tmp[i],
                          text: e.target.value,
                          value: i+1
                        })
                        setSelectBoxes(tmp)
                      }}
                    />
                  </Stack>
                  <Stack
                    width={'3rem'}
                    direction="row"
                    justifyContent="center"
                  >
                    <div>
                      {selectBoxes.length !== 1 && (
                        <IconButton
                          aria-label="delete"
                          color="error"
                          onClick={() => {
                            const tmp = [...selectBoxes]
                            tmp.splice(i, 1)
                            setSelectBoxes(tmp)
                          }}
                        >
                          <RemoveCircleIcon />
                        </IconButton>
                      )}
                    </div>
                  </Stack>
                </Stack>
              )
            })}
            <Stack direction="row" justifyContent="center">
              <div>
                <IconButton
                  aria-label="add"
                  color="primary"
                  size="large"
                  onClick={() => setSelectBoxes([...selectBoxes, { text: '', value: 0}])}
                >
                  <AddCircleIcon fontSize="large" />
                </IconButton>
              </div>
            </Stack>
          </>
        )}
        {getValues('type') === 'radio' && (
          <>
            <Typography variant="body1" component="p" fontWeight="bold">
              ラジオボタン項目の作成
            </Typography>
            {radios.map((v, i) => {
              return (
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="baseline"
                  key={i}
                >
                  <Stack flex={1}>
                    <TextField
                      required
                      margin="dense"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <EventIcon color="primary" />
                          </InputAdornment>
                        ),
                      }}
                      label="項目"
                      fullWidth
                      variant="standard"
                      value={v.text}
                      onChange={(e) => {
                        const tmp = [...radios]
                        tmp.splice(i, 1, {
                          ...tmp[i],
                          text: e.target.value,
                          value: i+1
                        })
                        setRadios(tmp)
                      }}
                    />
                  </Stack>
                  <Stack
                    width={'3rem'}
                    direction="row"
                    justifyContent="center"
                  >
                    <div>
                      {radios.length !== 1 && (
                        <IconButton
                          aria-label="delete"
                          color="error"
                          onClick={() => {
                            const tmp = [...radios]
                            tmp.splice(i, 1)
                            setRadios(tmp)
                          }}
                        >
                          <RemoveCircleIcon />
                        </IconButton>
                      )}
                    </div>
                  </Stack>
                </Stack>
              )
            })}
            <Stack direction="row" justifyContent="center">
              <div>
                <IconButton
                  aria-label="add"
                  color="primary"
                  size="large"
                  onClick={() => setRadios([...radios, { text: '', value: 0}])}
                >
                  <AddCircleIcon fontSize="large" />
                </IconButton>
              </div>
            </Stack>
          </>
        )}
        {getValues('type') === 'checkbox' && (
          <>
            <Typography variant="body1" component="p" fontWeight="bold">
              チェックボックス項目の作成
            </Typography>
          </>
        )}
        <Stack alignItems="center" justifyContent="center">
          <LoadingButton
            // disabled={Object.keys(errors).length > 0}
            variant="contained"
            loading={loading}
            type="submit"
            sx={{
              width: 200,
              mt: 4,
            }}
            color={'primary'}
            loadingPosition="end"
            endIcon={<AddTaskIcon />}
          >
            アンケート登録
          </LoadingButton>
        </Stack>
      </Box>
    </>
  )
}
